import React, { forwardRef } from 'react';
import MUIToggleButton, {
  ToggleButtonProps as MUIToggleButtonProps,
} from '@material-ui/lab/ToggleButton';

interface ToggleButtonProps extends MUIToggleButtonProps {}

const ToggleButton = forwardRef<HTMLButtonElement, ToggleButtonProps>(
  (props, ref) => {
    return <MUIToggleButton {...props} ref={ref} />;
  }
);

ToggleButton.displayName = 'ToggleButton';

export default ToggleButton;
